<div class="page-content">
    <div class="page-header">
        <h1>{{ title }}</h1>
        <div class="page-description">{{ subTitle }}</div>
    </div>
    <div class="page-body">
        <div class="container-fluid cards-container">
            @let kpi = kpis()[0];
            <div class="row g-3">
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.totalOperatingRevenueAmount.title"
                        [body]="{
                            value: kpi.totalOperatingRevenueAmount,
                            precision: texts.totalOperatingRevenueAmount.precision,
                            suffix: texts.totalOperatingRevenueAmount.suffix,
                        }"
                        [badge]="{
                            value: kpi.totalOperatingRevenueAmountEvolution,
                            suffix: texts.totalOperatingRevenueAmount.badgeSuffix,
                            precision: texts.totalOperatingRevenueAmount.badgePrecision,
                            style:
                                kpi.totalOperatingRevenueAmountEvolution! > 0
                                    ? 'success'
                                    : 'danger',
                        }"
                        [descriptionTitle]="texts.totalOperatingRevenueAmount.descriptionTitle"
                        [descriptionContent]="texts.totalOperatingRevenueAmount.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'totalOperatingRevenueAmount')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.totalOperatingExpensesAmount.title"
                        [body]="{
                            value: kpi.totalOperatingExpensesAmount,
                            precision: texts.totalOperatingExpensesAmount.precision,
                            suffix: texts.totalOperatingExpensesAmount.suffix,
                        }"
                        [badge]="{
                            value: kpi.totalOperatingExpensesAmountEvolution,
                            suffix: texts.totalOperatingExpensesAmount.badgeSuffix,
                            precision: texts.totalOperatingExpensesAmount.badgePrecision,
                            style:
                                kpi.totalOperatingExpensesAmountEvolution! < 0
                                    ? 'success'
                                    : 'danger',
                        }"
                        [descriptionTitle]="texts.totalOperatingExpensesAmount.descriptionTitle"
                        [descriptionContent]="texts.totalOperatingExpensesAmount.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'totalOperatingExpensesAmount')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.actualConcessionMarginRate.title"
                        [body]="{
                            value: kpi.actualConcessionMarginRate,
                            precision: texts.actualConcessionMarginRate.precision,
                            suffix: texts.actualConcessionMarginRate.suffix,
                        }"
                        [badge]="{
                            value: kpi.actualConcessionMarginRateEvolution,
                            suffix: texts.actualConcessionMarginRate.badgeSuffix,
                            precision: texts.actualConcessionMarginRate.badgePrecision,
                            style:
                                kpi.actualConcessionMarginRateEvolution! > 0 ? 'success' : 'danger',
                        }"
                        [descriptionTitle]="texts.actualConcessionMarginRate.descriptionTitle"
                        [descriptionContent]="texts.actualConcessionMarginRate.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'actualConcessionMarginRate')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.displayedConcessionMarginRate.title"
                        [body]="{
                            value: kpi.displayedConcessionMarginRate,
                            precision: texts.displayedConcessionMarginRate.precision,
                            suffix: texts.displayedConcessionMarginRate.suffix,
                        }"
                        [badge]="{
                            value: kpi.displayedConcessionMarginRateEvolution,
                            suffix: texts.displayedConcessionMarginRate.badgeSuffix,
                            precision: texts.displayedConcessionMarginRate.badgePrecision,
                            style:
                                kpi.displayedConcessionMarginRateEvolution! > 0
                                    ? 'success'
                                    : 'danger',
                        }"
                        [descriptionTitle]="texts.displayedConcessionMarginRate.descriptionTitle"
                        [descriptionContent]="
                            texts.displayedConcessionMarginRate.descriptionContent
                        "
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'displayedConcessionMarginRate')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <kpi-card
                        [title]="texts.mainKeyDistributedAmounts.title"
                        [body]="{
                            value: kpi.mainKeyDistributedAmounts,
                            precision: texts.mainKeyDistributedAmounts.precision,
                            suffix: texts.mainKeyDistributedAmounts.suffix,
                        }"
                        [descriptionTitle]="texts.mainKeyDistributedAmounts.descriptionTitle"
                        [descriptionContent]="texts.mainKeyDistributedAmounts.descriptionContent"
                        [isLoading]="!kpi.organizationId"
                        [error]="checkKpiErrors(kpi, 'mainKeyDistributedAmounts')"
                        cardClass="h-100">
                    </kpi-card>
                </div>
            </div>

            <chart-card
                id="operatingProductsChart"
                [title]="texts.operatingProductsEvolutionChart.title"
                [error]="operatingProductsChartError"
                [isLoading]="!operatingProductsChartData()[0].organizationId"
                [series]="operatingProductsChartSeries"
                [dataLabels]="operatingProductsDataLabels"
                [stacked]="true"
                [yaxis]="operatingProductsYaxis"
                [precision]="texts.operatingProductsEvolutionChart.precision"
                [xaxisTitle]="texts.operatingProductsEvolutionChart.xaxisTitle"
                [legend]="operatingProductsLegend"
                [customTooltip]="operatingProductsCustomTooltip"
                class="h-100">
            </chart-card>

            <chart-card
                id="operatingCostsChart"
                [title]="texts.operatingCostsEvolutionChart.title"
                [error]="operatingCostsChartError"
                [isLoading]="!operatingCostsChartData()[0].organizationId"
                [series]="operatingCostsChartSeries"
                [dataLabels]="operatingCostsDataLabels"
                [stacked]="true"
                [yaxis]="operatingCostsYaxis"
                [precision]="texts.operatingCostsEvolutionChart.precision"
                [xaxisTitle]="texts.operatingCostsEvolutionChart.xaxisTitle"
                [legend]="operatingCostsLegend"
                [customTooltip]="operatingCostsCustomTooltip"
                class="h-100">
            </chart-card>

            <div class="row g-3">
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="operatingResultChart"
                        [title]="texts.operatingResultEvolutionChart.title"
                        [error]="operatingResultChartError"
                        [isLoading]="!operatingResultChartData()[0].organizationId"
                        [series]="operatingResultChartSeries"
                        [dataLabels]="operatingResultDataLabels"
                        [stacked]="false"
                        [yaxis]="operatingResultYaxis"
                        [precision]="texts.operatingResultEvolutionChart.precision"
                        [grid]="operatingResultEvolutionGrid"
                        [xaxisTitle]="texts.operatingResultEvolutionChart.xaxisTitle"
                        [annotations]="operatingResultChartAnnotations"
                        class="h-100">
                    </chart-card>
                </div>
                <div class="col-sm-12 col-lg-6">
                    <chart-card
                        id="operatingMarginRateChart"
                        [title]="texts.operatingMarginRateEvolutionChart.title"
                        [error]="operatingMarginRateChartError"
                        [isLoading]="!operatingMarginRateChartData()[0].organizationId"
                        [series]="operatingMarginRateChartSeries"
                        [dataLabels]="operatingMarginRateDataLabels"
                        [stacked]="false"
                        [yaxis]="operatingMarginRateYaxis"
                        [precision]="texts.operatingMarginRateEvolutionChart.precision"
                        [grid]="operatingMarginRateGrid"
                        [xaxisTitle]="texts.operatingMarginRateEvolutionChart.xaxisTitle"
                        [annotations]="operatingResultChartAnnotations"
                        class="h-100">
                    </chart-card>
                </div>
            </div>
        </div>
    </div>
</div>
